export const permissions = [
    {id: 'canViewDashboard', name: 'View Dashboard'},
    {id: 'canViewHealthboard', name: 'View Healthboard'},
    {id: 'canViewEstablishments', name: 'View Establishments'},
    {id: 'canEditEstablishments', name: 'Edit Establishments'},
    {id: 'canViewUsers', name: 'View Users'},
    {id: 'canAssignMyRoles', name: 'Assign My Roles'},
    {id: 'canAssignAnyRoles', name: 'Assign Any Roles'},
    {id: 'canManageRoles', name: 'Manage Roles'},
    {id: 'canManagePeople', name: 'Manage People'},
    {id: 'canRequeueSync', name: 'Requeue Sync'},
    {id: 'canManageArborKeys', name: 'Manage Arbor Keys'}
];